import { createContext, FC, useContext, useState } from "react"
import { SearchReportsTransfers, WithChildren } from "../../../../../_metronic/helpers"

interface IFilterContext {
    filterExport: SearchReportsTransfers
    setFilterExport: React.Dispatch<React.SetStateAction<SearchReportsTransfers>>
}

const FilterContext = createContext<IFilterContext>({} as IFilterContext)

const FilterProvider: FC<WithChildren> = ({ children }) => {

    const [filterExport, setFilterExport] = useState<SearchReportsTransfers>({})

    return (
        <FilterContext.Provider
            value={{
                filterExport,
                setFilterExport,
            }}
        >
            {children}
        </FilterContext.Provider>
    )
}

const useFilterExport = () => useContext(FilterContext)
export { FilterProvider, useFilterExport }
